import { GOOGLE_CLIENT_ID, API_URL } from './config.js';
import { setSessionToken, setUser } from './api.js';

export function initGoogleAuth(onSuccess, onError) {
  if (!window.google) { onError('Google API not loaded yet. Refresh page.'); return; }

  window.google.accounts.id.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: async (response) => {
      try {
        const res = await fetch(API_URL + '/auth/google', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: response.credential })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Auth failed');
        // Flat object: data.token, data.email, data.role
        setSessionToken(data.token);
        setUser({ email: data.email, name: data.name, role: data.role, picture: data.picture });
        onSuccess(data);
      } catch (err) { onError(err.message); }
    }
  });

  window.google.accounts.id.renderButton(
    document.getElementById('google-signin-btn'),
    { theme: 'outline', size: 'large', width: 320, text: 'continue_with' }
  );
}
